import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID ?? '';

export const initAnalytics = (): void => {
    if (GA_MEASUREMENT_ID) {
        ReactGA.initialize(GA_MEASUREMENT_ID);
    } else {
        console.warn('Analytics: ID undefined. Events wont be sent');
    }
};

/**
 * Track a custom event
 */
export const trackEvent = (category: string, action: string, label?: string, value?: number): void => {
    try {
        ReactGA.event({
            category,
            action,
            label,
            value,
        });
    } catch (error) {
        console.error(['STAGE: ERROR GoogleAnalytics - trackEvent'], ['MESSAGE: Failed to track event'], error);
    }
};

/**
 * Track user login event
 */
export const trackLogin = (method = 'azure_b2c'): void => {
    trackEvent('User', 'Login', method);
};

/**
 * Track user logout event
 */
export const trackLogout = (): void => {
    trackEvent('User', 'Logout');
};

/**
 * Track button click event
 */
export const trackButtonClick = (buttonName: string, location?: string | null): void => {
    trackEvent('Button', 'Click', `${buttonName} ${location}`);
};

/**
 * Track form submission event
 */
export const trackFormSubmission = (formName: string, success = true): void => {
    trackEvent('Form', 'Submit', `${formName}_${success ? 'success' : 'error'}`);
};

/**
 * Track page view manually (useful for SPA navigation)
 */
export const trackPageView = (page: string): void => {
    try {
        ReactGA.send({ hitType: 'pageview', page });
    } catch (error) {
        console.error(['STAGE: ERROR GoogleAnalytics - trackPageView'], ['MESSAGE: Failed to track page view'], error);
    }
};
